import { changeValueWithOperand } from '../../../../widgets/search-form/utils/passengers';
import { generateSelection, isValidSelection } from './Passengers';

export const onAdultsCounterClick =
  (operand, adults, children, infants, childrenAges, infantsAges, onChange) => () => {
    const newAdults = changeValueWithOperand(adults, operand);
    const newInfants = Math.min(newAdults, infants);

    if (isValidSelection(newAdults, children, newInfants)) {
      onChange(generateSelection(newAdults, children, newInfants, childrenAges, infantsAges));
    }
  };
